import api from "./api";

const VehicleTaxService = {
  // ✅ CREATE a new vehicle tax
  create: async (data) => {
    const response = await api.post("/vehicleTax/save", data);
    return response.data;
  },

  // // ✅ GET all vehicle taxes
  // getAll: async () => {
  //   const response = await api.get("/vehicleTax/get");
  //   return response.data;
  // },

  getAll: async (companyId, pageNumber, noOfRows, search = "") => {
    const response = await api.get(
      `/vehicleTax/get?companyId=${companyId}&pageNumber=${pageNumber}&noOfRows=${noOfRows}&search=${search}`
    );
    return response.data;
  },

  // ✅ GET only active vehicle taxes
  getActive: async () => {
    const response = await api.get("/vehicleTax/active/list");
    return response.data;
  },

  // ✅ GET single vehicle tax by ID
  getById: async (id) => {
    const response = await api.get(`/vehicleTax/getById/${id}`);
    return response.data;
  },

  getByCompany: async (companyId) => {
    const res = await api.get(`/vehicleTax/getBycompany/${companyId}`);
    return res.data;
  },

  // ✅ UPDATE vehicle tax by ID
  update: async (id, data) => {
    const response = await api.put(`/vehicleTax/${id}`, data);
    return response.data;
  },

  // ✅ HARD DELETE vehicle tax by ID
  delete: async (id) => {
    const response = await api.delete(`/vehicleTax/${id}`);
    return response.data;
  },

  // ✅ TOGGLE STATUS (Active <-> Inactive)
  updateStatus: async (id) => {
    const response = await api.put(`/vehicleTax/updatestatus/${id}`);
    return response.data;
  },


  exportVehicleTax: async (companyId) => {
    const response = await api.get(`/vehicleTax/export?companyId=${companyId}`);
    return response.data;
  },
};

export default VehicleTaxService;
